export enum EEmitEventModal {
  Cancel = 'CANCEL',
  Ok = 'OK'
}
